<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
<div class="container mt-3">
    <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-6 pb-5">
            <!--Form with header-->
            <form>
                <div class="card border-primary rounded-0">
                    <div class="card-header p-0">
                        <div class="bg-info text-white text-center py-2">
                            <h3><i class="material-icons"></i> Dictionary</h3>
                        </div>
                    </div>
                    <div class="card-body p-3">

                        <!--Body-->
                        <div class="form-group">
                            <div class="input-group mb-2">
                                <div class="input-group-prepend mr-1">
                                    <div class="input-group-text"><span class="material-icons">
                                        create
                                        </span></div>
                                </div>
                                <input type="text" class="form-control-plaintext" [(ngModel)]="word" placeholder="search" name="word" (input)="findTheMeaning(word)">
                            </div>
                        </div>
                        <div class="form-group">
                            <table mdbTable small="true">
                                <tbody>
                                    <tr mdbTableCol *ngFor="let voc of searchedWord">
                                        <th scope="row">{{voc.word}}:</th>
                                        <td>{{voc.vocabularyDetail && voc.vocabularyDetail[0] && voc.vocabularyDetail[0].sentenceMeaning}}</td>
                                        <hr>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>

                </div>
            </form>
            <!--Form with header-->
        </div>
    </div>
</div>